import { render, staticRenderFns } from "./ChemistryMinigame.vue?vue&type=template&id=b2520c7c&scoped=true"
import script from "./ChemistryMinigame.vue?vue&type=script&lang=js"
export * from "./ChemistryMinigame.vue?vue&type=script&lang=js"
import style0 from "./ChemistryMinigame.vue?vue&type=style&index=0&id=b2520c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2520c7c",
  null
  
)

export default component.exports